'use client'

import classNames from 'classnames'
import React from 'react'
import type {
  FieldValues,
  RegisterOptions,
  UseFormRegister,
} from 'react-hook-form'

import { ReactComponent as CheckIcon } from '~/assets/icons/check.svg'

import InputErrorMessage from '../error-message'

interface Properties extends React.SelectHTMLAttributes<HTMLInputElement> {
  name: string
  register?: UseFormRegister<FieldValues>
  registerOptions?: RegisterOptions
  label?: string
  containerClassName?: string
  error?: string
}

const Confirm: React.FC<Properties> = ({
  register,
  registerOptions,
  name,
  label,
  containerClassName,
  id,
  error,
  ...rest
}) => {
  return (
    <fieldset
      className={classNames('w-full flex flex-col py-1', containerClassName)}
    >
      <label
        htmlFor={id ?? `confirm-${name}`}
        className="group flex gap-3 cursor-pointer"
      >
        <input
          type="checkbox"
          id={id ?? `confirm-${name}`}
          name={name}
          {...rest}
          {...register(name, registerOptions)}
          required={false}
          className="appearance-none hidden peer m-0"
        />
        <span
          className={classNames(
            'relative flex flex-none items-center justify-center border-2 w-5 h-5 border-current',
            'mt-1 rounded-md peer-checked:[&>.icon]:scale-100'
          )}
        >
          <CheckIcon
            width={19}
            height={14}
            className="icon w-3 h-auto scale-0 transition-transform !duration-200 lg:group-hover:scale-75 peer-checked:scale-100 ease-[cubic-bezier(.45,1.5,.5,.75)]"
          />
        </span>
        <span className="text-sm leading-tight">{label}</span>
      </label>
      {error && <InputErrorMessage message={error} className="!mt-4" />}
    </fieldset>
  )
}

export default Confirm
